import React from "react";

const LockIcon = (props) => {
    if(props.isLocked) {
        return (<span className="icon icon-lock" title="This option locked by parent organization" />);
    }
    return (<span />);
};

export default LockIcon;
